import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import {
  buildingCommonFields,
  buildingRevisionFields,
} from './common/buildingCommonFields';
import { allCleanPowerFields } from './common/cleanPowerFields';
import { msg } from '@lingui/core/macro';
import { electricityUsageQuantityField } from './common/electricityFields';
import { utilityCostFields } from './common/utilityCostFields';

export const electricityConsumptionMetadata = {
  displayName: msg({
    message: 'Facilities electricity consumption',
    context: 'Activity data schema name for facilities electricity consumption',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...buildingCommonFields,
    ...allCleanPowerFields,
    ...buildingRevisionFields,
    ...utilityCostFields,
    quantity: electricityUsageQuantityField,
    unit: genericUnitField,
    clean_power_percent_for_facility_overhead: {
      displayName: msg({
        message: 'Clean power percentage for facility overhead',
        context:
          'The percentage of clean power used to power the energy overhead of the datacenter (computed based on the `pue`)',
      }),
      externalDescription: msg({
        message:
          'The percentage of clean power used to power the energy overhead of the datacenter (computed based on the `pue`)',
        context: 'Clean power percentage for facility overhead',
      }),
    },
    pue: {
      displayName: msg({
        message: 'Power usage effectiveness',
        context:
          'The ratio of the total energy used to the amount of energy dedicated to powering datacenter equipment',
      }),
      externalDescription: msg({
        message:
          'The ratio of the total energy used to the amount of energy dedicated to powering datacenter equipment',
        context: 'Power usage effectiveness',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
